import Alpine from "alpinejs";
import messageBridge from "./utils/messageBridge";

// 찜 목록 API (tari-proxy). 서버 상한과 같다.
const WISHLIST_URL = "/apps/tari/wishlist";
const WISHLIST_MAX = 99;

export const initCustomer = () => {
  start();
};

const start = () => {
  Alpine.store("customer", {
    id: null,
    tags: null,
    name: null,
    email: null,
    orders_count: null,
    wishlist: Alpine.$persist({}).using(sessionStorage),
    isInit: Alpine.$persist(false).using(sessionStorage),
    async getToken() {
      try {
        const data = await fetch(
          `${window.Shopify.routes.root}account?view=token`,
          {
            method: "GET",
          }
        ).then((response) => response.text());

        return data;
      } catch (error) {
        return null;
      }
    },
    async setCustomer({ id, tags, name, email, orders_count, wishlist }) {
      this.id = id;
      this.tags = tags;
      this.name = name;
      this.email = email;
      this.orders_count = orders_count;

      // 찜 목록은 Liquid(고객 메타필드)가 매 페이지 내려주는 값이 기준이다. 서버 순서(앞이 최근)를 creationTime 으로 보존한다.
      const items = Array.isArray(wishlist) ? wishlist : [];
      this.wishlist = Object.fromEntries(
        items.map((item, index) => [
          item.productId,
          { ...item, creationTime: items.length - index },
        ])
      );
      this.isInit = true;
    },
    // /apps/tari/wishlist (App Proxy -> Supabase edge). 고객은 proxy 서명으로 식별하므로 토큰/고객 id 를 보내지 않는다.
    // 응답: { product_ids, count, max }. 실패: 401 비로그인, 422 가득 참, 404 없는 상품, 409 동시 쓰기 충돌
    async requestWishlist(method, body) {
      const response = await fetch(WISHLIST_URL, {
        method,
        credentials: "same-origin",
        headers: body ? { "Content-Type": "application/json" } : undefined,
        body: body ? JSON.stringify(body) : undefined,
      });

      if (!response.ok) {
        throw Object.assign(new Error(`wishlist ${response.status}`), {
          status: response.status,
        });
      }
      return response.json();
    },
    // 서버가 돌려준 목록에 없는 항목은 지운다(다른 탭/기기에서 바뀐 경우). 서버에는 있지만 화면용 정보가 없는 항목은 만들지 않는다.
    syncWishlist(productIds) {
      const ids = new Set((productIds || []).map(String));
      Object.keys(this.wishlist).forEach((id) => {
        if (!ids.has(String(id))) delete this.wishlist[id];
      });
    },
    async addWishlist({ title, productId, handle, variantId }) {
      if (window.Shopify.shop == "dev-wooltari.myshopify.com") {
        return null;
      }

      const customer = Alpine.store("customer").id;

      messageBridge.vibration();

      if (!customer) {
        return (window.location.href = "/account/login");
      }

      if (Object.keys(this.wishlist).length >= WISHLIST_MAX) {
        return Alpine.store("toast").create(window.$t("wishlist.max_add_item"));
      }

      this.wishlist = {
        ...this.wishlist,
        [productId]: {
          handle: handle,
          productId: parseInt(productId),
          variantId: parseInt(variantId),
          creationTime: Date.now(),
        },
      };

      try {
        const data = await this.requestWishlist("POST", {
          product_id: `${productId}`,
          op: "add",
        });
        this.syncWishlist(data.product_ids);
        return true;
      } catch (error) {
        delete this.wishlist[productId];

        if (error.status === 401) {
          return (window.location.href = "/account/login");
        }
        if (error.status === 422) {
          return Alpine.store("toast").create(window.$t("wishlist.max_add_item"));
        }
        console.log(error);
      }
    },

    async removeWishlist(productId, { title, handle, variantId }) {
      if (window.Shopify.shop == "dev-wooltari.myshopify.com") {
        return null;
      }

      const customer = Alpine.store("customer").id;

      if (!customer) {
        return (window.location.href = "/account/login");
      }

      const previous = this.wishlist[productId];
      delete this.wishlist[productId];

      try {
        const data = await this.requestWishlist("POST", {
          product_id: `${productId}`,
          op: "remove",
        });
        this.syncWishlist(data.product_ids);
        return true;
      } catch (error) {
        // 서버에 반영되지 않았으니 되돌린다
        if (previous) this.wishlist = { ...this.wishlist, [productId]: previous };

        if (error.status === 401) {
          return (window.location.href = "/account/login");
        }
        console.log(error);
      }
    },
  });
};
